var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"no-style clear-button",attrs:{"aria-label":("Clear the " + _vm.filter + " Filter")},on:{"click":_vm.clearFilter}},[_vm._t("default",function(){return [_vm._v("Clear Filter")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }